import React, { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { processSteps } from '../mockData';

gsap.registerPlugin(ScrollTrigger, useGSAP);

export default function ProcessSection() {
  const container = useRef();
  const headerRef = useRef();
  const stepsRef = useRef([]);

  useGSAP(() => {
    gsap.from(headerRef.current, {
      opacity: 0,
      y: 40,
      duration: 0.8,
      scrollTrigger: {
        trigger: container.current,
        start: "top 70%",
        end: "top 30%",
        scrub: 0.5,
      }
    });

    stepsRef.current.forEach((step, index) => {
      if (step) {
        gsap.from(step, {
          opacity: 0,
          x: index % 2 === 0 ? -50 : 50,
          duration: 0.8,
          scrollTrigger: {
            trigger: step,
            start: "top 85%",
            end: "top 40%",
            scrub: 0.5,
          }
        });
      }
    });
  }, { scope: container });

  return (
    <section id="process" ref={container} className="section section-dark">
      <div className="section-content">
        <div ref={headerRef} className="section-header">
          <div className="section-eyebrow">Our Methodology</div>
          <h2 className="section-title">From Capture to Submission</h2>
          <p className="section-description">
            A proven, disciplined approach that transforms your technical capabilities into winning proposals through strategic positioning and rigorous execution.
          </p>
        </div>

        <div className="process-timeline">
          {processSteps.map((step, index) => (
            <div 
              key={step.id}
              ref={(el) => stepsRef.current[index] = el}
              className="process-step"
            >
              <div className="process-number">{step.id}</div>
              <div className="process-phase">{step.phase}</div>
              <h3 className="process-title">{step.title}</h3>
              <p className="process-description">{step.description}</p>
              <ul className="process-details">
                {step.details.map((detail, idx) => (
                  <li key={idx}>{detail}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
